// extracted by mini-css-extract-plugin
export default {"collapseCarDataBtn":"CollapseDiv_collapseCarDataBtn__58aVG","bold":"CollapseDiv_bold__x0SO4"};